<script setup>
import ContentHeader from "@/components/Dashboard/ContentHeader.vue";
import KpiSection from "@/components/Dashboard/Courses/KPIs/kpiSection.vue";
</script>

<template>
  <ContentHeader :name="'KPIs'" />
  <KpiSection />
</template>
